 <template>
  <div class="position-relative">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" :class="{'popup-full top-0 bg-white':!data}" style="bottom: 0;z-index: 1042">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="px-4 bg-white rounded-top-6 position-relative" :class="{'rounded-none':!data}">
                <div class="pb-3 pt-4 border-bottom">
                  <div class="d-block" @click="onClose()">
                    <img src="../../../../assets/img/icon/close.png" width="15" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
                    <p class="mb-0 px-1 font-bold text-18 ls-2 d-inline-block ml-2">{{$t("hotel.choose-language")}}</p>
                  </div>
                  <p class="mb-0 ls-2 font-semibold text-12 color-grey pl-2 ml-4 position-relative">{{$t("hotel.choose-language-desc")}}</p>
                  <!-- <div class="row border no-gutters rounded-6">
                    <div class="col-11">
                      <input 
                        type="text" 
                        v-model="search"
                        placeholder="Search language here..." 
                        class="w-100 border-none search-c" />
                    </div>
                    <div class="col-1 text-right cursor-pointer" @click="clear()">
                      <img src="../../../../assets/img/icon/close.png" v-if="search != ''" width="23" class="border p-1 rounded-100 position-relative d-grid" style="top: 9px;left: -10px">
                    </div>
                  </div> -->
                </div>
                <div class="pt-2 pb-3">
                	<div class="row no-gutters mt-2 mb-3 pb-1 cursor-pointer" v-for="data in language" @click="toggleLanguage(data.iso_code)">
                		<div class="col-2">
                			<div class="position-relative text-center">
			                  <!-- <p class="mb-0 body-2-2 font-extrabold position-absolute m-auto text-white text-uppercase" style="width: 16px;top: 7px;">{{data.iso_code}}</p> -->
                        <img :src="data.image_url" class="p-0 language border">
			                </div>
                		</div>
                		<div class="col-8">
                      <p class="mb-0 body-2-2 text-14 font-bold" :class="{'text-green':data.iso_code == getCurrentLanguage()}" style="left: -5px;margin-top: 2px">{{data.name}}</p>
                			<p class="mb-0 body-2-2 text-10 font-bold text-uppercase" :class="{'text-green':data.iso_code == getCurrentLanguage()}" style="color: #8c8c8c;left: -5px;">{{data.iso_code}}</p>
                		</div>
                		<div class="col-2 text-right">
                			<div class="float-right d-block radio-button position-relative mt-2" :class="{'border-none bg-green':data.iso_code == getCurrentLanguage()}" style="top: 3px">
                				<img src="../../../../assets/img/icon/correct-white.png" width="11" class="mx-auto position-absolute" style="top: 6px;left: 6px;" v-if="data.iso_code == getCurrentLanguage()"></img>
                				<!-- <div class="active" v-if="data.iso_code == language_select"></div> -->
                			</div>
                		</div>
                	</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';

	export default{
		props: ['data'],
		data(){
      return {
      	search: '',
      	language_select: 'en',
      	language: '',
      	timer: 0
			}
		},
		computed: {
			filter_search(){
				return this.language.filter((item)=>{
					return item.title.toString().toLowerCase().match(this.search.toLowerCase())
				})
			}
		},
    mounted(){
      this.getLanguage()
    },
		methods: {
			...mapGetters(['getMerchant', 'getCurrentLanguage']),
      ...mapMutations(['setLanguageMutation']),
			clear(){
				this.search = ''
			},
      getLanguage(){
        this.language = this.getMerchant().language
      },
			onClose(){
				this.$emit('toggleLanguage', false)
			},
      toggleLanguage(data){
        this.setLanguageMutation(data)
        window.location.reload()
      },
			toggleLanguageChange(){
				if (this.data) {
					this.onClose()
					clearInterval(this.timer)
				}
			},
			onBack(data){
				this.language_select = data
        this.timer = setInterval(()=>{
        	this.toggleLanguageChange(data)
        }, 400)
			}
		}
	}
</script>
<style scoped>
::placeholder {
  color: #d8d8d8;
  font-size: 14px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
 color: #d8d8d8;
 font-size: 14px;
}

::-ms-input-placeholder { /* Microsoft Edge */
 color: #d8d8d8;
 font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/Language.vue